import { ViewModel } from '../view-model';

export class ApiFilteredItem implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Api Filtered';
  readonly apiRoute: string;

  itemId: string;

  json() {
    return this;
  }

  loadFromJson(data) {
    this.itemId = data;
  }
}
